import { useState } from "react"
import { UpdateUserFormErrors, UpdateUserFormI } from "./types"
import { SubjectRole } from "../../generated/graphql"
import { getFormErrors } from "./validation"

export const useUpdateUserForm = (initialForm: UpdateUserFormI) => {
    const [form, setForm] = useState<UpdateUserFormI>({ ...initialForm })
    const [formErrors, setFormErrors] = useState<UpdateUserFormErrors>({
        firstName: undefined,
        lastName: undefined,
    })

    const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target

        const updatedForm = {
            ...form,
            firstName: value,
        }

        // if there is a form error and the user is updating a first name input, we can clear it on valid input instead of waiting for blur
        // if there is no current error we should wait for blur
        // this creates a better user experience
        let updatedErrorForm = { ...formErrors }
        if (updatedErrorForm.firstName) {
            updatedErrorForm = getFormErrors(updatedForm)
        }

        setForm(updatedForm)
        setFormErrors(updatedErrorForm)
    }

    const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target

        const updatedForm = {
            ...form,
            lastName: value,
        }

        // See comment in handleFirstNameChange
        let updatedErrorForm = { ...formErrors }
        if (updatedErrorForm.lastName) {
            updatedErrorForm = getFormErrors(updatedForm)
        }

        setForm(updatedForm)
        setFormErrors(updatedErrorForm)
    }

    const handleUserRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target

        const updatedForm = {
            ...form,
            userRole: value as SubjectRole,
        }

        setForm(updatedForm)
    }

    const handleActiveUserChange = () => {
        const updatedForm = {
            ...form,
            activeUser: !form.activeUser,
        }

        setForm(updatedForm)
    }

    const handleFormBlur = () => {
        const updatedErrorForm = getFormErrors(form)
        setFormErrors(updatedErrorForm)
    }

    return {
        form,
        formErrors,
        handleFirstNameChange,
        handleLastNameChange,
        handleUserRoleChange,
        handleActiveUserChange,
        handleFormBlur,
    }
}
